import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ViewType } from '../models/view-type.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ViewTypeService {
  private apiUrl = environment.apiUrl + environment.viewTypePath;

  constructor(private http: HttpClient) {}

  getViewType(id: number): Observable<ViewType> {
    return this.http.get<ViewType>(`${this.apiUrl}/${id}`);
  }

  getViewTypes(): Observable<ViewType[]> {
    return this.http.get<ViewType[]>(`${this.apiUrl}${environment.statePath}/false`);
  }
}
